$(document).ready(function(){
    
    $('.gallery-box').each(function() {
        $(this).find('.galleries').magnificPopup({
            delegate: 'a',
            removalDelay: 300,
            showCloseBtn: true,
            mainClass: 'mfp-fade',
            gallery: {
                enabled: true,
                tCounter: '%curr% z %total%',
                tPrev: 'Předchozí',
                tNext: 'Další',
            },
            type: 'image'
        });
    });
    
});